<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="模板消息ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="32"
            v-decorator="[
              'messageId',
              {
                rules: [
                  { required: true, message: '请输入模板消息id,限制32个字' },
                ],
              },
            ]"
            placeholder="请输入模板消息id,限制32个字"
          />
        </a-form-item>
        <a-form-item
          label="模板消息名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'templateName',
              {
                rules: [
                  { required: true, message: '请输入模板消息名称,限制50个字' },
                ],
              },
            ]"
            placeholder="请输入模板消息名称,限制50个字"
          />
        </a-form-item>
        <a-form-item
          label="模板类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="xcxFlagHandle"
            v-decorator="[
              'templateType',
              { rules: [{ required: true, message: '请选择模板类型' }] },
            ]"
            placeholder="请选择模板类型"
            :triggerChange="true"
            dictCode="template_type"
          />
        </a-form-item>
        <a-form-item
          v-if="isXcxFlag"
          label="小程序模板类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="[
              'xcxTemplateType',
              { rules: [{ required: true, message: '请选择小程序类型' }] },
            ]"
            placeholder="请选择小程序类型"
            :triggerChange="true"
            dictCode="xcx_template_type"
          />
        </a-form-item>
        <a-form-item
          v-if="isXcxFlag"
          label="关联页面"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'pageId',
              { rules: [{ required: true, message: '请选择关联页面' }] },
            ]"
            placeholder="请选择关联页面"
          >
            <a-select-option
              v-for="(item, index) in pageList"
              :value="item.id"
              :key="index"
              >{{ item.pageName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          label="模板标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="['firstTitle']"
            placeholder="请输入模板标题"
          />
        </a-form-item>
        <a-form-item
          label="跳转地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="600"
            v-decorator="['jumpUrl']"
            placeholder="请输入跳转地址"
          />
        </a-form-item>
        <a-form-item
          label="模板关键词1"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="['keyword1']"
            placeholder="如该字段为日期，键入‘time’即可"
          />
        </a-form-item>
        <a-form-item :wrapperCol="wrapperCol">
          <a-button
            style="margin-left: 40px"
            @click="handleAddKeywords"
            type="primary"
            icon="plus"
            >添加关键词</a-button
          >
        </a-form-item>
        <a-form-item
          label="模板关键词"
          v-for="(item, index) in arr2"
          :key="index"
          :labelCol="labelCol"
        >
          <a-input
            style="width: 60%; margin-left: 20px; margin-top: 5px"
            type="text"
            :max-length="50"
            v-model="keywords[index]"
            placeholder="如该字段为日期，键入‘time’即可"
          />
          <a-button
            style="margin-left: 15px"
            @click="handleDelkeywords(index)"
            icon="minus-circle-o"
          ></a-button>
        </a-form-item>
        <a-form-item
          label="模板备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="['remark']"
            placeholder="请输入模板备注"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
import { getAction } from '../../../../api/manage';

let id = 0;
export default {
  name: 'MarketCrowdPushModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
  },
  data() {
    return {
      showEditor: false,
      showUpload: false,
      editorOption: {
        modules: {
          toolbar: [
            [
              'bold',
              { header: 1 },
              { header: 2 },
              { color: [] },
              { font: [] },
              { size: ['small', false, 'large', 'huge'] },
              'italic',
              'underline',
              'strike',
            ], // toggled buttons
            [
              'blockquote',
              { indent: '-1' },
              { indent: '+1' },
              { align: [] },
              'clean',
            ],
          ],
        },
      },
      headers: {
        authorization: 'authorization-text',
      },
      category: '0',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      modelId: '',
      arr2: [],
      keywords: [], //添加的模块集合
      newKeywords: [], //添加的模块集合
      isXcxFlag: false,
      pageList: [],
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/edit',
        getKeywords:
          process.env.VUE_APP_CMS_MARKETING + '/messageTemplate/getKeywords',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
        getPageList: process.env.VUE_APP_CMS_MARKETING + '/page/modules/all',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'xcxTemplateType',
            'pageId',
            'messageId',
            'templateName',
            'templateType',
            'firstTitle',
            'jumpUrl',
            'keyword1',
            'keywords',
            'remark'
          )
        );
      });

      if (this.model.templateType === '2') {
        this.isXcxFlag = true;
        this.xcxHandle();
      } else {
        this.isXcxFlag = false;
      }

      if (this.model.id) {
        this.getKeywords(this.model.id);
      } else {
        this.arr2 = [1];
        this.keywords = [];
      }
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);

          if (formData.templateType !== '2') {
            that.isXcxFlag = false;
            formData.pageId = '';
            formData.xcxTemplateType = '';
          }
          that.newKeywords = [];
          that.keywords.forEach((item) => {
            if (item.includes(',')) {
              item = item.replace(',', '，');
            }
            that.newKeywords.push(item);
          });
          that.keywords = that.newKeywords;
          // formData.keywords = JSON.stringify(that.keywords);
          formData.keywords = that.keywords;
          formData.keyword2 = '';
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'xcxTemplateType',
          'pageId',
          'messageId',
          'templateName',
          'templateType',
          'firstTitle',
          'jumpUrl',
          'keyword1',
          'keywords',
          'remark'
        )
      );
    },

    onEditorBlur() {
      //失去焦点事件
    },
    onEditorFocus() {
      //获得焦点事件
    },
    onEditorChange() {
      //内容改变事件
    },
    changeHandler(e) {
      this.isAward = e;
    },
    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },

    xcxHandle() {
      this.pageList = [];
      this.getPageList();
    },

    /**获取页面列表*/
    getPageList() {
      getAction(this.url.getPageList).then((res) => {
        if (res.success) {
          this.pageList = res.result;
          console.log(this.pageList);
        }
      });
    },
    prizeSourceHandle(e) {
      if (e === '1' || e === '2') {
        this.prizesList = [];
        this.getPrizesList(e);
        //this.showPrizeList = true;
      } else {
        this.prizesList = [];
        //this.showPrizeList = false;
      }
    },
    getKeywords(id) {
      this.confirmLoading = true;
      this.arr2 = [];
      this.keywords = [];
      getAction(this.url.getKeywords, { id: id }).then((res) => {
        if (res.success) {
          if (res.result.length !== 0) {
            console.log(res.result);
            //this.arr2 = res.result.length;
            res.result.forEach((item) => {
              this.keywords.push(item);
              this.arr2.push(this.keywords);
            });
            //this.pageModuleIds = this.arr2;
            console.log(this.arr2);
          } else {
            this.arr2 = [1];
            this.keywords = [];
          }
          this.confirmLoading = false;
        }
      });
    },
    handleAddKeywords() {
      let newarr2 = [1];
      this.arr2 = this.arr2.concat(newarr2);
      console.log(this.arr2);
    },

    handleDelkeywords(index) {
      console.log(index);
      this.arr2.splice(index, 1);
      this.keywords.splice(index, 1);
    },
    xcxFlagHandle(e) {
      if (e === '2') {
        this.isXcxFlag = true;
        this.xcxHandle();
      } else {
        this.isXcxFlag = false;
      }
    },
  },
};
</script>
